import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  Box,
  Grid,
  TableCell,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { Hidden } from '@mui/material';
import {
  ListTableCell,
  ListTableHeaderCell,
  ListTableRow
} from '../../../atoms/Table';
import { DeleteButton, EditButton } from '../../../atoms/Button';
import {
  SEARCH_STATUS_VALUES,
  SITE_TASK_STATUSES
} from '../../../../const/TaskConst';
import { SiteTaskHistoryModal } from '../../../parts/task/TaskHistoryModal';
import { SiteTaskAddModal } from '../../../parts/task/TaskAddModal';
import { SiteTaskEditModal } from '../../../parts/task/TaskEditModal';
import { SiteTaskDeleteModal } from '../../../parts/task/TaskDeleteModal';
import {
  getSiteTaskStatusName,
  getSiteTaskSearchStatusName
} from '../../../../utils/constLabel';
import { DEFAULT_MESSAGE_NO_DATA } from '../../../../const/Const';
import { ChangeEvent } from 'react';
import { useHooks } from './useHooks';
import { useStyles } from './useStyle';
import { Dispatch } from 'react';
import LoadingIcon from '../../../atoms/LoadingIcon';
import { Close } from '@material-ui/icons';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import LoadingIconClear from '../../../atoms/LoadingIconClear';
import { BasicSelect } from '../../input/BasicSelect';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../../../tooltip/CustomTooltip';
import { tooltipContents } from '../../../tooltip/Const';
import { useContext } from 'react';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export type TProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  constructId: number;
  afterUpdate: () => void;
  siteProcessId: number;
  viewAlert?: boolean;
  includeChildSiteProcess: boolean;
  setIncludeChildSiteProcess: Dispatch<boolean>;
};

export const SiteTaskListViewModal: React.FC<TProps> = (props: TProps) => {
  const {
    isOpen,
    setIsOpen,
    constructId,
    afterUpdate,
    siteProcessId,
    viewAlert,
    includeChildSiteProcess,
    setIncludeChildSiteProcess
  } = props;

  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const {
    siteTaskList,
    siteProcessList,
    searchSiteProcessId,
    searchStatus,
    isLoading,
    isOpenSiteTaskAdd,
    isOpenSiteTaskEdit,
    isOpenSiteTaskDelete,
    isOpenSiteTaskHistory,
    editSiteTaskId,
    deleteSiteTaskId,
    setIsOpenSiteTaskAdd,
    setIsOpenSiteTaskEdit,
    setIsOpenSiteTaskDelete,
    setIsOpenSiteTaskHistory,
    setEditSiteTaskId,
    setDeleteSiteTaskId,
    handleChangeSearchSiteProcess,
    handleChangeSearchStatus,
    handleChangeIncludeChildSiteProcess,
    renderSiteTaskDataTrigger,
    reRenderSiteTaskData,
    handleChangeStatus,
    lastElementRef,
    isSearching
  } = useHooks({
    isOpen,
    constructId,
    siteProcessId,
    includeChildSiteProcess,
    setIncludeChildSiteProcess,
    viewAlert
  });

  const classes = useStyles();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  return (
    <Dialog
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      className={classes.modal}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        afterUpdate();
      }}
      closeAfterTransition
      fullWidth={true}
    >
      {!isLoading && isSearching && (
        <div className={classes.loadingIconClearWrapper}>
          <LoadingIconClear />
        </div>
      )}
      {isLoading ? (
        <Grid
          container
          alignItems='center'
          justify='center'
          className={classes.loadingContainer}
        >
          <LoadingIcon />
        </Grid>
      ) : (
        <>
          <DialogTitle>
            <IconButton
              aria-label='close'
              className={classes.closeButton}
              onClick={() => {
                setIsOpen(false);
                afterUpdate();
              }}
            >
              <Close />
            </IconButton>
            <Grid container className={classes.gridContainerPadding}>
              <Grid item xs={12} sm={9} className={classes.flexWrap}>
                {/* 工程 セレクトボックス */}
                <Box className={classes.selectBoxContainer}>
                  <BasicSelect
                    className={`${classes.selectBox} ${classes.constructInput}`}
                    value={searchSiteProcessId}
                    onChange={handleChangeSearchSiteProcess}
                    disableUnderline
                  >
                    {siteProcessList.length > 0 &&
                      siteProcessList.map(siteProcess => (
                        <option
                          key={siteProcess.value}
                          value={siteProcess.value}
                        >
                          {siteProcess.label}
                        </option>
                      ))}
                  </BasicSelect>
                </Box>

                {/* ステータス セレクトボックス */}
                <Box className={classes.selectBoxContainer}>
                  <BasicSelect
                    className={classes.selectBox}
                    value={searchStatus}
                    onChange={handleChangeSearchStatus}
                    disableUnderline
                  >
                    {SEARCH_STATUS_VALUES.map(value => (
                      <option value={value} key={value}>
                        {getSiteTaskSearchStatusName(value)}
                      </option>
                    ))}
                  </BasicSelect>
                </Box>
                <Box
                  className={`${classes.flexWrap} ${classes.spaceBetween} ${classes.fullWidthRwd}`}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={includeChildSiteProcess}
                            onChange={handleChangeIncludeChildSiteProcess}
                            color='default'
                          />
                        }
                        label='小工程のタスクを含める'
                        className={classes.includeChildProcess}
                      />
                    </FormGroup>
                    <CustomTooltip title={tooltipContents.TaskView}>
                      <HelpIcon color='action' style={{ marginLeft: 2 }} />
                    </CustomTooltip>
                  </div>
                  {!isSmDownScreen && (
                    <CreateNewFolderIcon
                      onClick={() => {
                        setIsOpenSiteTaskAdd(true);
                      }}
                      className={classes.createNewFolderIcon}
                    />
                  )}
                </Box>
              </Grid>

              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <>
                  {isSmDownScreen && (
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      className={`${classes.textAlignRight} ${classes.flexEnd} ${classes.flexWrap} ${classes.paddingRight}`}
                    >
                      <EditButton
                        className={classes.nowrapWord}
                        onClick={() => {
                          setIsOpenSiteTaskAdd(true);
                        }}
                      >
                        タスクの追加
                      </EditButton>
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table stickyHeader aria-label='sticky table'>
                <TableHead>
                  <ListTableHeaderCell className={classes.headerCellLarge}>
                    タスク
                  </ListTableHeaderCell>
                  <ListTableHeaderCell className={classes.headerCellMedium}>
                    担当
                  </ListTableHeaderCell>
                  <ListTableHeaderCell
                    className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                  >
                    期限
                  </ListTableHeaderCell>
                  <ListTableHeaderCell
                    className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                  >
                    ステータス
                  </ListTableHeaderCell>
                  {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <ListTableHeaderCell
                      className={classes.headerCellLarge}
                    ></ListTableHeaderCell>
                  )}
                </TableHead>
                <TableBody>
                  {siteTaskList &&
                    siteTaskList.map((siteTask, index) => {
                      return (
                        <ListTableRow
                          key={siteTask.id}
                          ref={
                            index + 1 === siteTaskList.length
                              ? lastElementRef
                              : undefined
                          }
                        >
                          <ListTableCell
                            className={`${classes.headerCellLarge} ${classes.breakWord}`}
                          >
                            {siteTask.site_task_name}
                          </ListTableCell>
                          <ListTableCell
                            className={`${classes.headerCellMedium} ${classes.breakWord}`}
                          >
                            {siteTask.charge_user?.name || '--'}
                          </ListTableCell>
                          <ListTableCell
                            className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                          >
                            {siteTask.planned_end_date || '--'}
                          </ListTableCell>
                          <ListTableCell
                            className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                          >
                            <BasicSelect
                              className={`${classes.selectBox} ${classes.selectBoxInRow}`}
                              value={siteTask.status}
                              onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                handleChangeStatus(e, siteTask.id);
                              }}
                              disableUnderline
                            >
                              {SITE_TASK_STATUSES.map(value => (
                                <option value={value} key={value}>
                                  {getSiteTaskStatusName(value)}
                                </option>
                              ))}
                            </BasicSelect>
                          </ListTableCell>
                          {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                            <ListTableCell>
                              <div className={classes.listTableButtonContainer}>
                                <EditButton
                                  onClick={() => {
                                    setEditSiteTaskId(siteTask.id);
                                    setIsOpenSiteTaskEdit(true);
                                  }}
                                >
                                  編集
                                </EditButton>
                                <DeleteButton
                                  onClick={() => {
                                    setDeleteSiteTaskId(siteTask.id);
                                    setIsOpenSiteTaskDelete(true);
                                  }}
                                >
                                  削除
                                </DeleteButton>
                              </div>
                            </ListTableCell>
                          )}
                        </ListTableRow>
                      );
                    })}
                  {(!siteTaskList || siteTaskList.length === 0) && (
                    <>
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          className={classes.centerMessage}
                        >
                          {DEFAULT_MESSAGE_NO_DATA}
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </>
      )}

      {/* タスク追加モーダル */}
      <SiteTaskAddModal
        isOpen={isOpenSiteTaskAdd}
        setIsOpen={setIsOpenSiteTaskAdd}
        afterSubmit={reRenderSiteTaskData}
        constructId={constructId}
        siteProcessId={searchSiteProcessId}
      />

      {/* タスク編集モーダル */}
      <SiteTaskEditModal
        isOpen={isOpenSiteTaskEdit}
        setIsOpen={setIsOpenSiteTaskEdit}
        afterUpdate={reRenderSiteTaskData}
        afterDelete={reRenderSiteTaskData}
        constructId={constructId}
        siteTaskId={editSiteTaskId}
      />

      {/* タスク削除モーダル */}
      <SiteTaskDeleteModal
        isOpen={isOpenSiteTaskDelete}
        setIsOpen={setIsOpenSiteTaskDelete}
        afterSubmit={reRenderSiteTaskData}
        siteTaskId={deleteSiteTaskId}
      />

      {/* タスク更新履歴モーダル */}
      <SiteTaskHistoryModal
        constructId={constructId}
        isOpen={isOpenSiteTaskHistory}
        setIsOpen={setIsOpenSiteTaskHistory}
      />
    </Dialog>
  );
};
